export enum RealMoneyStatus {
  OK = 'OK',
  REQUIRED = 'REQUIRED',
  UPDATE_REQUIRED = 'UPDATE_REQUIRED',
  VERIFICATION_REQUIRED = 'VERIFICATION_REQUIRED'
}

export enum DepositStatus {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ANOTHER_IN_PROGRESS = 'ANOTHER_IN_PROGRESS',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
  BONUS_ACK_REQUIRED = 'BONUS_ACK_REQUIRED',
  COMPLETED = 'COMPLETED',
  ERRORS = 'ERRORS',
  ERR_PLAID_ACCOUNT_REQUIRED = 'ERR_PLAID_ACCOUNT_REQUIRED',
  FAILED = 'FAILED',
  GOOGLE_PAY_CANCELED = 'GOOGLE_PAY_CANCELED',
  GOOGLE_PAY_FAILED = 'GOOGLE_PAY_FAILED',
  GOOGLE_PAY_SESSION_TIMEOUT = 'GOOGLE_PAY_SESSION_TIMEOUT',
  INITIAL = 'INITIAL',
  PARTIALLY_COMPLETED_CHECK = 'PARTIALLY_COMPLETED_CHECK',
  PRECASHING_TIMEOUT = 'PRECASHING_TIMEOUT',
  PROTECTED_BALANCE_ACK_REQUIRED = 'PROTECTED_BALANCE_ACK_REQUIRED',
  RATE_CHANGED = 'RATE_CHANGED',
  REDIRECT = 'REDIRECT',
  REJECTED = 'REJECTED',
  REJECTED_AGE_VERIFY = 'REJECTED_AGE_VERIFY',
  REJECTED_BONUS_MIN_DEPOSIT_REQUIRED = 'REJECTED_BONUS_MIN_DEPOSIT_REQUIRED',
  REJECTED_CARD_BLOCKED = 'REJECTED_CARD_BLOCKED',
  REJECTED_CARD_NOT_VERIFIED = 'REJECTED_CARD_NOT_VERIFIED',
  REJECTED_MAX_DEPOSITS_LIMIT_EXCEEDED = 'REJECTED_MAX_DEPOSITS_LIMIT_EXCEEDED',
  REJECTED_PAYTRU_NSF_ERROR = 'REJECTED_PAYTRU_NSF_ERROR',
  REJECTED_SELF_EXCLUDED = 'REJECTED_SELF_EXCLUDED',
  REJECTED_TEMP_ACCOUNT_LIMIT_EXCEEDED = 'REJECTED_TEMP_ACCOUNT_LIMIT_EXCEEDED',
  REJECTED_X3D_SECURE2_REDIRECT = 'REJECTED_X3D_SECURE2_REDIRECT',
  REJECTED_X3D_SECURE2_REQUIRED_ERROR = 'REJECTED_X3D_SECURE2_REQUIRED_ERROR',
  REJECTED_X3D_SECURE_REQUIRED_ERROR = 'REJECTED_X3D_SECURE_REQUIRED_ERROR',
  RMF_REQUIRED = 'RMF_REQUIRED',
  TIMEOUT = 'TIMEOUT',
  UPSELL_OFFER = 'UPSELL_OFFER',
  WRONG_PWD = 'WRONG_PWD'
}

export enum TransactionStatus {
  APPROVED = 'A',
  PENDING = 'P',
  REJECTED = 'R',
  WAITING = 'W'
}

export enum PaySystemErrorCode {
  AuthenticationRequired = 'AuthenticationRequired',
  HostileCard = 'HostileCard',
  InstantBonusAcknowledgement = 'InstantBonusAcknowledgement',
  NoBankTransfers = 'NoBankTransfers',
  NotAvailable = 'notAvailable',
  RMFRequired = 'RMFRequired',
  RateChanged = 'RateChanged',
  RepeatedCashinDeclineOptions = 'RepeatedCashinDeclineOptions',
  TempAccountLimitReached = 'TempAccountLimitReached',
  WbtBankNotAvailable = 'WbtBankNotAvailable',
  WithdrawMethodNotAvailable = 'WithdrawMethodNotAvailable'
}

export enum CashoutStatus {
  ANOTHER_IN_PROGRESS = 'ANOTHER_IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  COMPLETED_PARTIALLY = 'COMPLETED_PARTIALLY',
  ERRORS = 'ERRORS',
  ERR_BANK_ACCOUNT_NOT_FOUND = 'ERR_BANK_ACCOUNT_NOT_FOUND',
  ERR_BANK_ACCOUNT_NOT_VALIDATED = 'ERR_BANK_ACCOUNT_NOT_VALIDATED',
  FAILED = 'FAILED',
  INITIAL = 'INITIAL',
  IN_GRACE_PERIOD = 'IN_GRACE_PERIOD',
  NOT_ALLOWED = 'NOT_ALLOWED',
  NOT_VERIFIED_ACCOUNT = 'NOT_VERIFIED_ACCOUNT',
  OK = 'OK',
  PARTIALLY_COMPLETED_CHECK = 'PARTIALLY_COMPLETED_CHECK',
  PENDING_CASHOUTS = 'PENDING_CASHOUTS',
  REJECTED = 'REJECTED',
  REJECTED_CARD_BLOCKED = 'REJECTED_CARD_BLOCKED',
  RMF_REQUIRED = 'RMF_REQUIRED',
  TAX_CHANGED = 'TAX_CHANGED',
  TEMP_ACCOUNT_CASHOUT_LIMIT_EXCEEDED = 'TEMP_ACCOUNT_CASHOUT_LIMIT_EXCEEDED',
  TIMEOUT = 'TIMEOUT',
  TOO_EARLY_TO_CASHOUT = 'TOO_EARLY_TO_CASHOUT'
}
